module.exports = __webpack_public_path__ + "static/project-13b-e14fa7ad2ef88af254740ce6a509ca4a.png";